import { render, staticRenderFns } from "./maquinas.vue?vue&type=template&id=2e242f5c&scoped=true"
import script from "./maquinas.vue?vue&type=script&lang=js"
export * from "./maquinas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e242f5c",
  null
  
)

export default component.exports